__turbopack_context__.v({
  "buttonSimple": "get-notified1440px-module-scss-module__tMoN8a__buttonSimple",
  "container": "get-notified1440px-module-scss-module__tMoN8a__container",
  "form": "get-notified1440px-module-scss-module__tMoN8a__form",
  "getnotified1440px": "get-notified1440px-module-scss-module__tMoN8a__getnotified1440px",
  "inputs": "get-notified1440px-module-scss-module__tMoN8a__inputs",
  "leftcol": "get-notified1440px-module-scss-module__tMoN8a__leftcol",
  "sescriptor": "get-notified1440px-module-scss-module__tMoN8a__sescriptor",
  "subscribe": "get-notified1440px-module-scss-module__tMoN8a__subscribe",
  "title": "get-notified1440px-module-scss-module__tMoN8a__title",
});
